import * as React from 'react';

interface SectionFrameProps {
  /** Kept on the API for backwards-compat, but NOT rendered any more —
   *  the surrounding settings menu already labels each section, so a
   *  duplicate H2 was visual noise. Existing call sites keep passing
   *  `title` / `description`; we just drop them here. */
  title?: string;
  description?: string;
  children: React.ReactNode;
  /** Optional element rendered top-right (e.g. a section-level button).
   *  When provided we still render a single right-aligned action row
   *  even though the title block is gone. */
  action?: React.ReactNode;
}

/**
 * Lightweight wrapper used by every settings section so the visual
 * rhythm stays consistent. As of the heading-cleanup pass the H2 is no
 * longer rendered — the surrounding menu is the only label. The frame
 * only contributes spacing + an optional action row now.
 */
export function SectionFrame({ action, children }: SectionFrameProps) {
  return (
    <div className="flex flex-col gap-4">
      {action && <div className="flex justify-end">{action}</div>}
      <div className="space-y-4">{children}</div>
    </div>
  );
}
